import { useSites } from "@/Composables/useSites";
import { computed } from "vue";
import { uniq } from "lodash";

export function useLinkedToBreadcrumbs() {
    const { isLoading: isLoadingSites, data: sites } = useSites();

    const buildings = computed(() => {
        if (isLoadingSites.value) {
            return [];
        }
        return sites.value;
    });

    const getBreadcrumbs = (spaceId) => {
        if (!spaceId) {
            return [];
        }

        const breadcrumbs = [];

        const findParent = (id, nodes) => {
            for (const node of nodes) {
                if (node.id === id) {
                    breadcrumbs.unshift(node.name);
                    if (node.parentId) {
                        findParent(node.parentId, buildings.value);
                    }
                    if (node.tenantId) {
                        breadcrumbs.unshift(
                            buildings.value.find(
                                (building) => building.id === node.tenantId
                            ).name
                        );
                    }
                    break;
                }
                if (node.children) {
                    findParent(id, node.children);
                }
            }
        };

        findParent(spaceId, buildings.value);

        return uniq(breadcrumbs);
    };

    return {
        getBreadcrumbs,
    };
}
